import { Templates } from "./Templates";

export class TimedMessageBox {
	private static readonly uiTemplate:string =
		'<div class="messageBox"></div>';
	
	/**displays a message for the length of time requested
	 * @param message - the message to display
	 * @param msDuration - the duration, in milliseconds*/
	constructor(message:string,
			msDuration:number, { 
			textAlign = "center"}: { 
				textAlign?:string}){
		let div = Templates.createDiv(TimedMessageBox.uiTemplate);
		div.innerHTML = message;
		div.style.textAlign = textAlign;
		document.body.append(div);
		setTimeout(() => div.remove(), msDuration);
	}
}